/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import React, { useState, useContext, useEffect } from 'react';
import {
  VFGlobalContext,
  ADD_EDITING_DATA,
} from '@mummssoftware/global-context/VFGlobalContext';
import { OrdersGlobalContext } from '@mummssoftware/global-context';
import { useTheme } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import { CPFContext } from '../../containers/Context/CPFContext';
import { CarePlanFrequencyContext } from '../../context';
import { PlusPRN } from '../../utils/constant';
import { isAideOrVolunteerRoleGroup } from './utils';
import {
  getStagedOrderEntry,
  buildOrderEntryPayload,
} from './orderEntryHelpers';
import {
  getWidgetEditMode,
  getCellEditRights,
  CPF_EDIT_MODE,
  CPF_SAVE_VIA,
  CpfEditMode,
} from '../../editPolicy';

export const PrnCell = (props: any) => {
  const { data, rgHash, isEditable, editMode: editModeProp } = props;
  const { roleGroupId, name, id, orderEntryId, stagedPrn: rowStagedPrn } = data;
  const { isPRNOrderAgency, isCPFAgency, editingRoleGroupId } = useContext(
    CPFContext,
  );
  const { dispatchVF, VForderData, VFordersMode } = useContext(VFGlobalContext);
  const { orderType } = useContext(OrdersGlobalContext);
  const { readOnly } = useContext(CarePlanFrequencyContext);

  const {
    palette: { text },
  } = useTheme() as any;

  const mode: CpfEditMode =
    editModeProp ||
    getWidgetEditMode({
      isCPFAgency: !!isCPFAgency,
      isPRNOrderAgency: !!isPRNOrderAgency,
      VFordersMode,
    });

  const isActiveRow =
    !!isEditable ||
    editModeProp === CPF_EDIT_MODE.ORDER ||
    (editingRoleGroupId != null &&
      String(editingRoleGroupId) === String(roleGroupId));

  const hidePrnForRole = isAideOrVolunteerRoleGroup(roleGroupId);
  // Agency/role visibility stays local; write gate comes from policy.
  const agencyShowsPrn = (isPRNOrderAgency || isCPFAgency) && !hidePrnForRole;

  const carePlan =
    roleGroupId != null ? rgHash?.[roleGroupId.toString()] : null;

  const frequency = carePlan?.frequencies?.[id] || carePlan?.frequencies?.dummy;

  const rights = getCellEditRights({
    mode,
    column: PlusPRN,
    isActiveRow,
    carePlan: frequency,
    readOnly,
  });
  const { write: allowWrite } = rights;
  // Agency/role decides visibility; policy write = interactive (order dialog).
  const showPrn = agencyShowsPrn;
  const canToggle = allowWrite && agencyShowsPrn;

  const prnFreq = frequency ? frequency.prn : carePlan?.prn;
  const stagedEntry = getStagedOrderEntry(
    data,
    VForderData,
    VFordersMode,
    roleGroupId,
  );

  const stagedPrn =
    stagedEntry?.prn !== undefined ? stagedEntry.prn : rowStagedPrn;
  const [PRN, setPRN] = useState(stagedPrn ?? prnFreq ?? false);

  useEffect(() => {
    if (!allowWrite) {
      if (stagedPrn !== undefined) {
        setPRN(stagedPrn);
      } else if (stagedEntry) {
        if (stagedEntry.prn) {
          setPRN(stagedEntry.prn);
        } else if (stagedEntry.prn === false) {
          setPRN(stagedEntry.prn);
        }
      }
    }
  }, [stagedPrn, stagedEntry?.prn, allowWrite]);

  useEffect(() => {
    if (allowWrite && canToggle && rights.saveVia === CPF_SAVE_VIA.ORDER) {
      dispatchVF({
        type: ADD_EDITING_DATA,
        payload: buildOrderEntryPayload(
          { roleGroupId, name, orderEntryId },
          { prn: PRN, orderType },
        ),
      });
    } else if (frequency) {
      frequency.editPrn = prnFreq;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const PRNClick = () => {
    if (!canToggle) return;
    if (frequency) {
      frequency.editPrn = !PRN;
    }
    if (rights.saveVia === CPF_SAVE_VIA.ORDER) {
      dispatchVF({
        type: ADD_EDITING_DATA,
        payload: buildOrderEntryPayload(
          { roleGroupId, name, orderEntryId },
          { prn: !PRN },
        ),
      });
    }
    setPRN(!PRN);
  };

  if (carePlan) {
    return (
      <div>
        {showPrn ? (
          <Checkbox
            onClick={PRNClick}
            color="secondary"
            name="PN"
            disabled={!canToggle}
            style={{
              color: text.primary,
              padding: '0px',
            }}
            checked={PRN}
          />
        ) : null}
      </div>
    );
  }
  return null;
};

export default PrnCell;
